import React from 'react';
import { classNames } from '../../util/classNames';
import { Step } from './Step';

export type Steps = {
  name: string;
  isComplete: boolean;
  isCurrent: boolean;
};

type Props = {
  steps: Steps[];
};
export const SnapStepper = (props: Props) => {
  const { steps } = props;
  const getNextStepCompleted = (currentStep: number) => {
    return steps[currentStep + 1]?.isComplete;
  };
  const nextUncompletedStep = steps.filter((step) => !step.isComplete)[0];

  return (
    <nav aria-label='Progress'>
      <ol className='flex w-full items-center justify-center p-2'>
        {steps.map((step, stepIdx) => (
          <li
            key={step.name}
            className={classNames(
              stepIdx !== steps.length - 1 ? 'pr-12 desktop:pr-[119px]' : '',
              'relative',
            )}
          >
            <Step
              {...step}
              stepNumber={stepIdx + 1}
              nextStepCompleted={getNextStepCompleted(stepIdx)}
              isNextStep={nextUncompletedStep?.name === step.name || false}
            />
          </li>
        ))}
      </ol>
    </nav>
  );
};
